import React, { useEffect } from 'react';

import { useReportingLines, useReportingLinesStore } from '@atlassian/teams';

import ManagersAndTeamsChart from './ReportingLines';
import { useReportingLines as DEPRECATED_useReportingLines } from './ReportingLines/hooks';
import { useReportingLinesStore as DEPRECATED_useReportingLinesStore } from './store';

type ReportingLinesWithQueryProps = {
	userId: string;
	product?: string;
};

export const DEPRECATED_ReportingLinesWithQuery = (
	props: ReportingLinesWithQueryProps,
): React.JSX.Element => {
	const { userId } = props;

	const [{ selectedUserId }, { selectUser }] = DEPRECATED_useReportingLinesStore();
	const userToMakeRequestFor = selectedUserId ?? userId;
	const reportingLinesResponse = DEPRECATED_useReportingLines(userToMakeRequestFor);

	useEffect(() => {
		selectUser(userId);
	}, [userId, selectUser]);

	return <ManagersAndTeamsChart {...props} reportingLinesResponse={reportingLinesResponse} />;
};

export const ReportingLinesWithQuery = (props: ReportingLinesWithQueryProps): React.JSX.Element => {
	const { userId } = props;

	const [{ selectedUserId }, { selectUser }] = useReportingLinesStore();
	const userToMakeRequestFor = selectedUserId ?? userId;
	const reportingLinesResponse = useReportingLines(userToMakeRequestFor);

	useEffect(() => {
		selectUser(userId);
	}, [userId, selectUser]);

	return <ManagersAndTeamsChart {...props} reportingLinesResponse={reportingLinesResponse} />;
};
